
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../helpers";
// SOFTDELETEAUTHUSER
// SOFTDELETEAUTHUSER
const SOFTDELETEAUTHUSER= createAsyncThunk(
  "softDeleteAuthUser/softDeleteAuthUser",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const softDeleteAuthUserSlice = createSlice({
  name: "softDeleteAuthUserSlice",
  initialState: {
    softDeleteAuthUser: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfsoftDeleteAuthUser: (state) => {
        state.softDeleteAuthUser.loading = false
        state.softDeleteAuthUser.error = false
        state.softDeleteAuthUser.data = []
        state.softDeleteAuthUser.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(SOFTDELETEAUTHUSER.fulfilled, (state, action) => {
      state.softDeleteAuthUser = {
        ...state.softDeleteAuthUser,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SOFTDELETEAUTHUSER.pending, (state, action) => {
      state.softDeleteAuthUser = {
        ...state.softDeleteAuthUser,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(SOFTDELETEAUTHUSER.rejected, (state, action) => {
      state.softDeleteAuthUser = {
        ...state.softDeleteAuthUser,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const softDeleteAuthUserAction = {
    SOFTDELETEAUTHUSER,
};

export { softDeleteAuthUserAction };
export default softDeleteAuthUserSlice.reducer;
export const {setInitialStateOfsoftDeleteAuthUser} = softDeleteAuthUserSlice.actions
